module.exports = __webpack_public_path__ + "static/media/Car Truck.1c6bab01.svg";